import React from 'react';
import { getEditorColor } from '../../util/ColorUtil';
import {
  isItUndefined,
  modifyLinks,
  renderTextColor,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';
import { useRouter } from 'next/router';

const SmallLogoWall = ({
  data,
  text,
  renderLogos,
  returnBackground,
  getWidth,
  getAlignment,
  isH2ClassStyled,
}) => {
  const emphasizedTextColor = getEditorColor(text);
  const { locale } = useRouter();

  return (
    <div
      className={`small-logo-wall${isH2ClassStyled ? ' headline-h2-class-styled' : ''}`}
    >
      <div className={'inner-container'}>
        {text && (
          <div className={'text ' + getAlignment()}>
            <h2
              className={`${isH2ClassStyled ? 'h2-class-styled' : ''} ${data?.regionColor ? renderTextColor(data?.regionColor) : ''} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              dangerouslySetInnerHTML={{
                __html: modifyLinks(text, locale)
                  .replace(/<\/?p>/gi, '')
                  .replace(/<\/?h2>/gi, ''),
              }}
            />
          </div>
        )}
        <div
          dangerouslySetInnerHTML={{
            __html: cleanHTML(
              modifyLinks(
                isItUndefined(data?.children?.field_logo_wall_description),
                locale
              )
            ),
          }}
          className={`description`}
        />
        {!getWidth() && (
          <div className={'logos-container ' + returnBackground()}>
            {renderLogos()}
          </div>
        )}
      </div>
      {getWidth() && (
        <div className={'logos-container ' + returnBackground()}>
          {renderLogos()}
        </div>
      )}
    </div>
  );
};

export default SmallLogoWall;
